/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppointmentListApiResponse } from '../../models/appointment-list-api-response';

export interface GetAppointments$Json$Params {

/**
 * Start date for the query range
 */
  startDate?: string;

/**
 * End date for the query range
 */
  endDate?: string;
}

export function getAppointments$Json(http: HttpClient, rootUrl: string, params?: GetAppointments$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AppointmentListApiResponse>> {
  const rb = new RequestBuilder(rootUrl, getAppointments$Json.PATH, 'get');
  if (params) {
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AppointmentListApiResponse>;
    })
  );
}

getAppointments$Json.PATH = '/api/Calendar/appointments';
